module.exports = __webpack_public_path__ + "img/login.86b8a04e.png";